export default __webpack_public_path__ + "static/media/bg_5.d37ae405.jpg";